import { render, staticRenderFns } from "./DownloadContents.vue?vue&type=template&id=29dedc7a&scoped=true"
import script from "./DownloadContents.vue?vue&type=script&lang=ts"
export * from "./DownloadContents.vue?vue&type=script&lang=ts"
import style0 from "./DownloadContents.vue?vue&type=style&index=0&id=29dedc7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dedc7a",
  null
  
)

export default component.exports